import { DateTime } from 'luxon';

import type { IPoll } from '~/lib/api/modules/Polls';

export type IPollStatus = 'ended' | 'programmed' | 'running' | 'inactive';

export type IPollInfo = {
  startAt?: DateTime;
  endAt?: DateTime;
  ended: boolean;
  started: boolean;
  running: boolean;
  programmedAt?: DateTime;
  status: IPollStatus;
};

export const getPollInfo = (poll: IPoll): IPollInfo => {
  const startAt = poll.startDate ? DateTime.fromISO(poll.startDate) : undefined;
  const endAt = poll.endDate ? DateTime.fromISO(poll.endDate) : undefined;
  const ended = endAt ? endAt < DateTime.now() : false;
  const started = startAt ? startAt < DateTime.now() : true;
  const running = started && !ended;
  const programmedAt = !running && !ended ? startAt : undefined;
  const status: IPollStatus = ended
    ? 'ended'
    : poll.active
      ? programmedAt
        ? 'programmed'
        : running
          ? 'running'
          : 'ended'
      : 'inactive';

  return {
    startAt,
    endAt,
    ended,
    started,
    running,
    programmedAt,
    status,
  };
};
